import { CircularProgress } from "@mui/material";
import "./overlay.scss";

interface IOverlay {
	active?: boolean;
	message?: string;
	showLoader?: boolean;
}

const Overlay = ({ active, message, showLoader }: IOverlay) => {
	return (
		<div id="overlayContainer" className={active ? "" : "hidden-element"}>
			{showLoader === true && <CircularProgress size={60} />}
			<div id="overlayMessage">{message}</div>
		</div>
	);
};

export default Overlay;
